import React from 'react';
import { Button } from '../ui/Button';
import { CountdownTimer } from '../ui/CountdownTimer';
import { CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24 bg-slate-950 px-4 scroll-mt-10" data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <div className="bg-slate-900 rounded-3xl shadow-2xl border border-slate-700 overflow-hidden" data-id="element-110">
          <div className="bg-blue-950 p-8 text-center relative overflow-hidden" data-id="element-111">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500 rounded-full blur-3xl opacity-20 -mr-10 -mt-10" data-id="element-112"></div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 relative z-10" data-id="element-113">
              Oferta Especial de Lanzamiento
            </h2>
            <p className="text-slate-300 relative z-10" data-id="element-114">
              Empieza tu carrera como editor profesional hoy
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-115">
            <div className="mb-6" data-id="element-116">
              <span className="text-slate-500 line-through text-xl font-medium" data-id="element-117">
                Precio real: $150.000 ARS
              </span>
              <div className="flex items-center justify-center gap-3 mt-2" data-id="element-118">
                <span className="text-white text-5xl md:text-6xl font-extrabold tracking-tight" data-id="element-119">
                  $59.000
                </span>
                <span className="text-slate-500 font-medium text-lg mt-4" data-id="element-120">
                  ARS
                </span>
              </div>
            </div>

            {/* Cuotas */}
            <div className="bg-blue-950/50 border border-blue-900/50 rounded-xl p-4 mb-6 inline-flex items-center gap-3" data-id="element-121">
              <CreditCard className="w-5 h-5 text-blue-400 flex-shrink-0" data-id="element-122" />
              <span className="text-blue-300 font-semibold text-sm md:text-base" data-id="element-123">
                O pagá en 3 cuotas sin interés de $19.667 ARS
              </span>
            </div>

            <div className="bg-red-950/50 border border-red-900 rounded-2xl p-6 mb-8" data-id="element-124">
              <p className="text-red-400 font-bold mb-4" data-id="element-125">
                Este precio está disponible solo por tiempo limitado por
                lanzamiento.
              </p>
              <CountdownTimer data-id="element-126" />
            </div>

            <Button href="https://brunocairo.com/checkouts/cn/hWN9d9LNaqEHoVMgvxz2ena6/es-ar?_r=AQABm5dgdg20OJYxL1tr8gcCs9ZD5-sayP96XU9opQQ6yDg&preview_theme_id=156155707625" size="xl" fullWidth className="text-xl mb-4" data-id="element-127">
              Quiero acceder ahora
            </Button>

            <p className="text-sm text-slate-500 mt-4" data-id="element-128">
              Pago único o en 3 cuotas sin interés. Acceso de por vida a todas
              las actualizaciones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}